export default __webpack_public_path__ + "static/media/radio-active.8779adbb.svg";